export const chartColors = {
  brand500: '#3b82f6',
  brand600: '#2563eb',
  emerald500: '#10b981',
  amber500: '#f59e0b',
  rose500: '#f43f5e',
  violet500: '#8b5cf6',
  purple500: '#a855f7',
  pink500: '#ec4899',
  cyan500: '#06b6d4',
  slate100: '#f1f5f9',
  slate200: '#e2e8f0',
  slate300: '#cbd5e1',
  slate400: '#94a3b8',
  slate500: '#64748b',
  slate700: '#334155',
  slate800: '#1e293b',
  slate900: '#0f172a',
  white: '#ffffff',
} as const;

export interface ChartTheme {
  gridColor: string;
  textColor: string;
  tooltipBg: string;
  tooltipColor: string;
  tooltipBorder: string;
}

export function getChartTheme(isDark: boolean): ChartTheme {
  return {
    gridColor: isDark ? chartColors.slate800 : chartColors.slate100,
    textColor: isDark ? chartColors.slate400 : chartColors.slate500,
    tooltipBg: isDark ? chartColors.slate900 : chartColors.white,
    tooltipColor: isDark ? chartColors.slate200 : chartColors.slate900,
    tooltipBorder: `1px solid ${isDark ? chartColors.slate800 : chartColors.slate200}`,
  };
}
